









































    import { Component, Vue, Prop } from 'vue-property-decorator';

    @Component({
        inheritAttrs: false,
    })
    export default class EULAAgreementModal extends Vue {
        @Prop({ default: null }) public value: string;

        public termsAndConditionsAccepted = false;
        public privacyPolicyAccepted = false;

        get isAccepted() {
            return this.termsAndConditionsAccepted && this.privacyPolicyAccepted;
        }

        get ucla() {
           return this.value;
        }

        set ucla(value) {
            this.$emit('input', value);
        }
}
